const buildDate = process.env.VUE_APP_BUILD_DATE || "";
const buildVersion = process.env.VUE_APP_BUILD_VERSION || "";

function formatBuildLabel() {
  const parts = [];

  if (buildDate) {
    parts.push(buildDate);
  }

  if (buildVersion) {
    parts.push(buildVersion);
  }

  return parts.length > 0 ? `Ver: ${parts.join(" ")}` : "Ver:";
}

export const buildLabel = formatBuildLabel();
